import editorconfig from "refractor/editorconfig";
export default editorconfig;